import { EcomPlatformViewerScriptContext } from '../../viewer-script/types';
import { toCart } from './toCart';
import { toCheckout } from './toCheckout';
import { toThankYouPage } from './toThankYouPage';

export const createNavigatePublicApi = ({
  context,
  origin,
}: {
  context: EcomPlatformViewerScriptContext;
  origin: string;
}) => {
  return {
    toCart: toCart({ context, origin }),
    toCheckout: toCheckout({ context }),
    toThankYouPage: toThankYouPage({ context, origin }),
  };
};
